import React from 'react';
import { CheckCircleOutlined, CloseOutlined } from "@mui/icons-material";
import { LinearProgress } from "@mui/material";
export const SyncProgressSectionLayout = (props) => {
    const { sectionTitle, loading, complete, error } = props;
    let sectionWidth = 172.89;
    if (sectionTitle.includes('recent report')) {
        sectionWidth = 182.89;
    }
    if (error) {
        return (React.createElement("div", { style: { width: sectionWidth, height: 70, justifyContent: 'flex-start', alignItems: 'center', gap: 12 } },
            React.createElement("div", { style: { flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 3, display: 'flex' } },
                React.createElement("div", { style: { textAlign: 'center', color: 'rgba(0, 0, 0, 0.87)', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, sectionTitle),
                React.createElement("div", { style: { width: 16, height: 16, position: 'relative' } },
                    React.createElement(CloseOutlined, { style: { color: '#D32F2F' } }))),
            React.createElement(LinearProgress, { variant: 'determinate', value: 100, style: {
                    color: '#D32F2F',
                    marginTop: '15px',
                    marginRight: '10px',
                    marginLeft: '10px'
                }, sx: {
                    '& .MuiLinearProgress-bar1Determinate': {
                        backgroundColor: '#D32F2F',
                    }
                } })));
    }
    if (complete) {
        return (React.createElement("div", { style: { width: sectionWidth, height: 70, justifyContent: 'flex-start', alignItems: 'center', gap: 12 } },
            React.createElement("div", { style: { flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 3, display: 'flex' } },
                React.createElement("div", { style: { textAlign: 'center', color: 'rgba(0, 0, 0, 0.87)', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, sectionTitle),
                React.createElement("div", { style: { width: 16, height: 16, position: 'relative' } },
                    React.createElement(CheckCircleOutlined, { style: { color: '#2C78EB' } }))),
            React.createElement(LinearProgress, { variant: 'determinate', value: 100, style: {
                    color: '#2C78EB',
                    marginTop: '15px',
                    marginRight: '10px',
                    marginLeft: '10px'
                } })));
    }
    return (React.createElement("div", { style: { width: sectionWidth, height: 70, justifyContent: 'flex-start', alignItems: 'center', gap: 12 } },
        React.createElement("div", { style: { flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', gap: 3, display: 'flex' } },
            React.createElement("div", { style: { textAlign: 'center', color: 'rgba(0, 0, 0, 0.87)', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, sectionTitle),
            React.createElement("div", { style: { width: 16, height: 16, position: 'relative' } },
                React.createElement(CheckCircleOutlined, { style: { color: '#0000008F' } }))),
        React.createElement(LinearProgress, { variant: loading ? 'indeterminate' : 'determinate', value: 0, style: {
                color: loading ? '#2C78EB' : '#BBDEFB',
                marginTop: '15px',
                marginRight: '10px',
                marginLeft: '10px'
            } })));
};
